<!-- Findings and advice for one field. Advice is not a problem, so it never reads as one:
     it says which value applies, and offers to fill it in. -->
<ng-template #fieldMessages let-name>
  <div *ngFor="let problem of problemsFor(name)" class="text-danger small mt-1">
    {{ problem }}
  </div>
  <div *ngFor="let entry of adviceFor(name)" class="text-muted small mt-1">
    {{ entry.Message }}
    <a *ngIf="entry.SuggestedValue" href="javascript:void(0)"
       (click)="applyAdvice(name, entry.SuggestedValue)">
      {{ 'exactOnlineSettings.applyAdviceText' | translate }}
    </a>
  </div>
</ng-template>

<div class="card col-lg-12 col-md-12 col-sm-12">
  <div class="card-header">
    <h4 class="card-title" id="basic-layout-form">{{ 'exactOnlineSettings.title' | translate }}</h4>
    <p class="mb-0">{{ 'exactOnlineSettings.text' | translate }}</p>
  </div>
  <div class="card-body">
    <div class="px-3">
      <!-- These are credentials for a machine-to-machine integration, not a sign-in. Without the
           opt-out a browser password manager offers to save and fill them, and injects its own
           markup into the form to do so. -->
      <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="form-body">
          <div formArrayName="formSettings">

            <ng-container *ngFor="let entry of renderedGroups; trackBy: trackGroup">
              <h4 class="form-section">
                <i [ngClass]="entry.group.icon"></i> {{ entry.group.titleKey | translate }}
              </h4>
              <p class="text-muted">{{ entry.group.descriptionKey | translate }}</p>

              <!-- The placeholder is an example value, or the value that applies when the field is
                   left empty. It never repeats the label. -->
              <div *ngFor="let field of entry.fields; trackBy: trackField"
                   [ngSwitch]="field.settingTypeCode">

                <div *ngSwitchCase="settingType.text">
                  <div class="form-group" [formGroupName]="field.index">
                    <label>{{ field.displayName }}</label>
                    <input type="text" class="form-control" formControlName="value"
                           [readonly]="field.isReadOnly" [placeholder]="field.placeholder">
                    <ng-container *ngTemplateOutlet="fieldMessages; context: { $implicit: field.name }">
                    </ng-container>
                  </div>
                </div>

                <div *ngSwitchCase="settingType.password">
                  <div class="form-group" [formGroupName]="field.index">
                    <label>{{ field.displayName }}</label>
                    <div class="input-group">
                      <input [type]="field.control.value.passwordType" class="form-control"
                             formControlName="value"
                             [readonly]="field.isReadOnly" [placeholder]="field.placeholder"
                             autocomplete="off" data-lpignore="true" data-1p-ignore>
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <a data-original-title="" title="toggle"
                             (click)="togglePassword(field.index, field.control.value.passwordType)">
                            <i [ngClass]="passwordIconClass"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                    <ng-container *ngTemplateOutlet="fieldMessages; context: { $implicit: field.name }">
                    </ng-container>
                  </div>
                </div>

                <div *ngSwitchCase="settingType.number">
                  <div class="form-group" [formGroupName]="field.index">
                    <label>{{ field.displayName }}</label>
                    <input type="number" class="form-control" formControlName="value"
                           [readonly]="field.isReadOnly" [placeholder]="field.placeholder">
                    <ng-container *ngTemplateOutlet="fieldMessages; context: { $implicit: field.name }">
                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngIf="entry.group.titleKey === tokenGroupKey" class="form-group">
                <p class="mb-0">
                  <span *ngIf="connection.IsConnected">
                    {{ 'exactOnlineSettings.connectedText' | translate }}
                  </span>
                  <span *ngIf="!connection.IsConnected">
                    {{ 'exactOnlineSettings.notConnectedText' | translate }}
                  </span>
                </p>
              </div>
            </ng-container>
          </div>
        </div>

        <div *ngIf="hasValidationProblems" class="alert alert-danger" role="alert">
          <strong>{{ 'exactOnlineSettings.validationFailedText' | translate }}</strong>
          <ul *ngIf="generalProblems.length" class="mb-0 mt-1 pl-4">
            <li *ngFor="let problem of generalProblems">{{ problem }}</li>
          </ul>
        </div>

        <div class="form-actions">
          <button class="btn btn-raised btn-raised btn-warning mr-1" type="button" (click)="resetForm()">
            <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
          </button>
          <button [disabled]="!dynamicForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
            <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
          </button>
          <button [disabled]="isLoginDisabled" class="btn btn-raised btn-raised btn-primary mr-1" type="button"
                  (click)="login()" [title]="'exactOnlineSettings.loginHelpText' | translate">
            <i class="icon-key"></i> {{ 'exactOnlineSettings.loginText' | translate }}
          </button>
          <button [hidden]="!connection.IsConnected" class="btn btn-raised btn-raised btn-primary mr-1"
                  type="button" (click)="test()" [title]="'exactOnlineSettings.testHelpText' | translate">
            <i class="fa fa-check"></i> {{ 'buttons.testSettingsText' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
